import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { API_CLEAR_UNTRACKED_CALL } from 'services/dataService/resources/callManagement/constants';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';

interface UseClearCallProps {
  onSuccess?: () => void;
}

export const useClearCall = ({
  onSuccess,
}: UseClearCallProps | undefined = {}) => {
  const { t } = useTranslation();

  const { mutate, isLoading } = useMutation({
    mutationFn: (callId: string) => {
      return clearCall(callId);
    },
    onSuccess: (data) => {
      if (data?.response) {
        notificationController.success({
          message: t('labels.untrackedInboundCallClearedSuccessfully'),
        });
      }
      onSuccess?.();
    },
    onError: (error) => {
      let message = t('labels.somethingWentWrong');
      if (error instanceof Error) {
        message = error.message;
      }
      notificationController.error({
        message,
      });
    },
  });

  return {
    mutate,
    isLoading,
  };
};

const clearCall = async (callId: string) => {
  const url = API_CLEAR_UNTRACKED_CALL(callId);
  const { error, data } = await dataService.createOne<{ response: string }>(
    url,
    {},
  );
  if (error) {
    throw new Error(error);
  }
  if (!data) {
    return undefined;
  }
  return {
    response: data.response,
  };
};
